module.exports = __webpack_public_path__ + "img/图层 19.f46f4575.png";